/**
 *  Define service to process get a quote form request
 */
import { Injectable } from "@angular/core";
import { AES, enc } from "crypto-js";
import * as globals from "./global";

@Injectable()
export class LocalStorageService {
    
  private static storage: any = sessionStorage;
  /**
   * Set value in local storage
   * @method set
   */
  static set(key: string, value: any, prefix: boolean = true): any {
    value = LocalStorageService.bsEncrypt(value);
    LocalStorageService.storage.setItem(key, value);
  }

  /**
   * Get value form local storage
   * @method get
   */
  static get(key: string, prefix: boolean = true): any {
    let data = LocalStorageService.storage.getItem(key);
    data = LocalStorageService.bsDecrypt(data);
    if (data != null && data !== '{}') {
      try {
        return JSON.parse(data);
      } catch (error) {}
    }
    return null;
  }

  /**
   * clear local storages
   * @method flush
   */
  static flush(key?: string, prefix: boolean = true, exception: any = null) {
    const exceptionItem = [];
    let i = 0;
    if (key != null && key !== undefined) {
      LocalStorageService.storage.removeItem(key);
    } else {
      if (exception) {
        exception.forEach(element => {
          exceptionItem[i] = LocalStorageService.get(element);
          i++;
        });
        i = 0;
        // const exceptionItem = LocalStorageService.get(exception);
        LocalStorageService.storage.clear();
        exception.forEach(element => {
          LocalStorageService.set(element, exceptionItem[i]);
          i++;
        });
      } else {
        LocalStorageService.storage.clear();
      }
    }
  }

  /**
   * use to encrypt data
   * @method bsEncrypt
   */
  static bsEncrypt(data: string) {
    const newString: any = JSON.stringify(data);
    return AES.encrypt(newString, globals.SECRET).toString();
  }

  /**
   * use to decrypt data
   * @method bsDecrypt
   */
  static bsDecrypt(data: string) {
    if (!data) {
      return data;
    }
    const newString: any = AES.decrypt(data, globals.SECRET);
    return newString.toString(enc.Utf8);
  }
}
